import { IState } from '../../store';

export function getIsMapServicesEnabled(state: IState) {
  return state.featureToggle.mapServicesEnabled;
}
